/**
 * @class
 * @description This class contains the properties required to load many PEO clients from the PrismHR API.
 * @export
 * @name PeoClientApiManyRequestModel
 */
export class PeoClientApiManyRequestModel {

  /**
   * @description This method is used to create a new instance of the PeoClientApiLoadManyRequestModel class.
   * @memberof PeoClientApiManyRequestModel
   * @method
   * @name PeoClientApiManyRequestModel.Factory()
   * @param {string} [peoId] The unique PrismHR identifier for the PEO.
   * @param {string} [clientId] The unique PrismHR identifier for the client.
   * @public
   * @returns {PeoClientApiManyRequestModel} The new instance of the PeoClientApiLoadManyRequestModel class.
   * @static
   */
  public static Factory(peoId?: string, clientId?: string): PeoClientApiManyRequestModel {

    // Define our response model.
    const model = new PeoClientApiManyRequestModel();

    // Set the peo id into our response model if it was provided.
    if (!!peoId) model.peoId = peoId;

    // Set the client id into our response model if it was provided.
    if (!!clientId) model.clientId = clientId;

    // We're done, return our response model.
    return model;
  }

  /**
   * @description This property contains the unique PrismHR identifier for the client.
   * @memberof PeoClientApiManyRequestModel
   * @name PeoClientApiManyRequestModel#clientId
   * @property
   * @public
   * @type {string}
   */
  public clientId!: string;

  /**
   * @description This property contains the unique PrismHR identifier for the PEO.
   * @memberof PeoClientApiManyRequestModel
   * @name PeoClientApiManyRequestModel#peoId
   * @property
   * @public
   * @type {string}
   */
  public peoId!: string;
}
